// extracted by mini-css-extract-plugin
export default {"container":"MR-z","error":"NR-z","disabled":"OR-z","submit":"PR-z","option":"QR-z","success":"RR-z","failure":"SR-z"};